// extracted by mini-css-extract-plugin
export default {"slider":"PopUpSlider_slider__g0IFA","item":"PopUpSlider_item__vy7zn"};